export const MIN_ZIP_ZODE_LENGTH = 2;
export const NMBER_OF_HEADERS_CONTACS_CSV = 4;

export const GOOGLE_REPLY_CHARACTERS = 4000;

export const businessPropertiesToCheck =[
    'name'
]

export const locationPropertiesToCheck =[
    'name',
    'address'
]

export const contactPropertiesToCheck =[
    'fullName',
    'email',
    'phoneNumber'
]

export const resellerPropertiesToCheck =[
    'name'
]

export const days = [
    '0','1','2','3','4','5','6','7',
    '8','9','10','11','12','13','14',
    '15','16','17','18','19','20','21',
    '22','23','24','25','26','27','28',
    'Last day'
]

export const FACEBOOK_REPLY_CHARACTERS = 8000;